import React from "react"

const Circles = ({ previewData, headerColor, textColor }) => {
  return (
    <div
      style={{
        paddingTop: "10px",
        flexWrap: "wrap",
        flexDirection: "row",
        display: "flex",
        marginBottom: "10px",
        marginLeft: "5px",
      }}
    >
      {previewData.map((x, index) => (
        <div
          style={{
            width: "80px",
            height: "70px",
            margin: "10px",
            marginTop: "30px",
            textAlign: "-webkit-center",
            backgroundColor: headerColor,
          }}
          key={index}
        >
          <div
            style={{
              backgroundImage: `url("${x?.image?.url}")`,
              backgroundColor: "white",
              width: "60px",
              height: "60px",
              backgroundSize: "cover",
              borderRadius: "50%",
              transform: "translate(0px, -20px)",
              border: "1px solid white",
              backgroundPosition: "center",
            }}
          />
          <span
            style={{
              color: textColor,
              transform: "translate(0px, -15px)",
              display: "inline-block",
            }}
          >
            {x?.name}
          </span>
        </div>
      ))}
    </div>
  )
}

export default Circles
